// ============================================================
// constants/navItems.js — Super Admin navigation menu config
// ============================================================

import { ShieldPlus, SettingsIcon, TableConfig, Megaphone } from "lucide-react";

const LABELS = {
  en: {
    ConfigurationManagement: "Configurations",
    AdminAccountCreation: "Admin Accounts",
    Broadcasts: "Broadcasts",
    Settings: "Settings",
  },
  ar: {
    ConfigurationManagement: "إعدادات الشركات",
    AdminAccountCreation: "حسابات الأدمن",
    Broadcasts: "الإعلانات",
    Settings: "الإعدادات",
  },
};

/**
 * Each item: { icon, text, page }
 * `page` matches the route segment and the switch-case in renderCurrentPage.
 * `text` follows the interface language.
 */
export const buildNavItems = (language = "en") => {
  const l = LABELS[language === "ar" ? "ar" : "en"];
  return [
    { icon: TableConfig,  text: l.ConfigurationManagement, page: "ConfigurationManagement" },
    { icon: ShieldPlus,   text: l.AdminAccountCreation,    page: "AdminAccountCreation"    },
    { icon: Megaphone,    text: l.Broadcasts,              page: "Broadcasts"              },
    { icon: SettingsIcon, text: l.Settings,                page: "Settings"                },
  ];
};

export const navItems = buildNavItems("en");
